import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

export type FilterComboBoxItem = {
  label: string;
  value: string;
};

export type FilterComboBoxChange = {
  values?: string[];
  query: string;
};

@Component({
  selector: 'app-filter-combo-box',
  templateUrl: './filter-combo-box.component.html',
  standalone: false,
})
export class FilterComboBoxComponent {
  @Input() filterId = '';
  @HostBinding('attr.id') get id(): string | null {
    return this.filterId || null;
  }
  @Input() accessibleLabel = '';
  @Input() placeholder = '';
  @Input() items: FilterComboBoxItem[] = [];
  @Input() values: string[] = [];

  @Output() selectionChange = new EventEmitter<FilterComboBoxChange>();

  onComboBoxChange(event: CustomEvent<FilterComboBoxChange>): void {
    this.selectionChange.emit(event.detail);
  }
}
